module.exports = __webpack_public_path__ + "static/media/phone.e09c1091.png";